module.exports = __webpack_public_path__ + "media/images/title__bg-e89d915266569a55d275724347951bad.png";